import Utility from './UtilityFunctions';

export function hashScroll() {
    if (!Utility.hasHash()) {
        return;
    }

    Utility.windowReady(() => {
        const targetElm = $(window.location.hash);

        if (targetElm.length < 1) {
            return;
        }

        Utility
            .scrollToElem(targetElm, Utility.getScrollOffset(true))
            .promise()
            .then(() => {
                // emulate click on parent <a></a> to toggle accordion (Policy View only)
                if (targetElm.hasClass('accordion-title')) {
                    targetElm.parent().parent()
                        .parent()
                        .toggleClass('is-active');
                    targetElm.parent().find('.accordion-content')
                        .slideToggle();
                }
            });
    });
}
